import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../../queries/withCount';

import { CORE_ASSET_FIELDS } from 'app/src/components/Assets/queries';

const ERRORS = `errors { path, message }`;

const FEE_ESTIMATE_FIELDS = `
  id,
  type,
  buyerFee,
  asset {
    ${CORE_ASSET_FIELDS}
    stockNumber
    vin
    category
    seller { id, name }
  }
  saleAsset { id }
  amount
  counterAmount
  description
  status
  activeFor
  original { id, amount, counterAmount, description}
  prior { id, amount, counterAmount, description}
  createdBy { id, fullName }
  acceptedBy { id, fullName }
  acceptMethod
`

const FEE_ESTIMATE_VARIABLES = `
  $counterAmount: Decimal
  $originalId: ID
  $priorId: ID
  $status: String
  $activeFor: String
`;

const FEE_ESTIMATE_ARGUMENTS = `
  counterAmount: $counterAmount
  originalId: $originalId
  priorId: $priorId
  status: $status
  activeFor: $activeFor
`;

const FEE_ESTIMATE_FIELDS_AND_ERRORS = `
  feeEstimate {
    ${FEE_ESTIMATE_FIELDS}
  }
  ${ERRORS}
`;

export const FEE_ESTIMATES_WITH_COUNT = gql`
  query (
    ${WITH_COUNT_VARIABLES}
    $assetId: ID
  ) {
    feeEstimatesWithCount(
      ${WITH_COUNT_ARGUMENTS}
      assetId: $assetId
    ) {
      entries {
        ${FEE_ESTIMATE_FIELDS}
      }
      count
    }
  }
`;

export const UPDATE_FEE_ESTIMATE = gql`
  mutation UpdateFeeEstimate(
    $id: ID!
    ${FEE_ESTIMATE_VARIABLES}
    $acceptedById: ID
    $acceptedByType: String
    $acceptMethod: String
  ) {
    updateFeeEstimate(
      id: $id
      ${FEE_ESTIMATE_ARGUMENTS}
      acceptedById: $acceptedById
      acceptedByType: $acceptedByType
      acceptMethod: $acceptMethod
    ) {
      ${FEE_ESTIMATE_FIELDS_AND_ERRORS}
    }
  }
`;

export const FEE_ESTIMATE = gql`
  query FeeEstimate($id: ID!) {
    feeEstimate(id: $id) {
      ${FEE_ESTIMATE_FIELDS}
    }
  }
`;

export const HIDE_FEE_ESTIMATE = gql`
  mutation HideFeeEstimate($id: ID!) {
    hideFeeEstimate(id: $id) {
      feeEstimate {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;